// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UsTe","field":"styles_field__1jGI8","fieldCol":"styles_fieldCol__hOw0n","diffCol":"styles_diffCol__2hzZt","diff":"styles_diff__1e_wR"};